<template>
  <div class="big health-care-card">
    <div class="page_title flex_between">
      <span>{{ $route.query.card_title }}统计</span>
      <el-button type="primary" style="width: 120px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="overview">
          <el-card class="box-card">
            <div class="value">
              {{ healthCareCardInfo.people_num }}/{{
                healthCareCardInfo.buy_num
              }}
            </div>
            <div class="label">购买人数/购买次数</div>
          </el-card>
          <el-card class="box-card">
            <div class="value">{{ healthCareCardInfo.drug_reduce_price }}</div>
            <div class="label">药品优惠金额</div>
          </el-card>
          <el-card class="box-card">
            <div class="value">{{ healthCareCardInfo.goods_reduce_price }}</div>
            <div class="label">商城优惠金额</div>
          </el-card>
          <el-card class="box-card">
            <div class="value">{{ healthCareCardInfo.give_integral }}</div>
            <div class="label">赠送积分</div>
          </el-card>
        </div>

        <div class="search_box">
          <div class="item">
            <span class="itemtitle">用户昵称</span>
            <el-input
              v-model="healthCareCardForm.nick_name"
              clearable
              style="width: 180px"
              size="small"
              maxlength="30"
              placeholder="请输入"
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">用户手机号</span>
            <el-input
              v-model="healthCareCardForm.phone"
              clearable
              style="width: 200px"
              size="small"
              maxlength="20"
              placeholder="请输入用户名称或手机号"
              @change="search"
            ></el-input>
          </div>

          <div class="item">
            <span class="itemtitle">购买时间</span>
            <el-date-picker
              v-model="healthCareCardForm.buy_time"
              type="daterange"
              align="right"
              size="small"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 230px"
              @change="search"
            >
            </el-date-picker>
          </div>

          <div class="item">
            <span class="itemtitle">购买次数</span>
            <div class="item-content">
              <el-input-number
                v-model="healthCareCardForm.buy_num_start"
                :min="0"
                :max="999999"
                :precision="0"
                :controls="false"
                size="small"
                placeholder="请输入数字"
              ></el-input-number>
              <span>-</span>
              <el-input-number
                v-model="healthCareCardForm.buy_num_end"
                :min="0"
                :max="999999"
                :precision="0"
                :controls="false"
                size="small"
                placeholder="请输入数字"
              ></el-input-number>
            </div>
          </div>

          <div class="item">
            <div class="itemtitle">是否到期</div>
            <el-radio-group v-model="healthCareCardForm.is_expire">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>

          <div class="item">
            <span class="itemtitle">购买渠道</span>
            <el-select
              v-model="healthCareCardForm.channel_type"
              placeholder="请选择"
              size="small"
              clearable
              style="width: 160px"
            >
              <el-option label="个人中心" :value="1"></el-option>
              <el-option label="购买处方" :value="2"></el-option>
              <el-option label="购买商品" :value="3"></el-option>
              <el-option label="VIP陪诊购买" :value="4"></el-option>
            </el-select>
          </div>

          <div class="item">
            <el-button
              type="primary"
              style="margin-left: 20px"
              size="small"
              @click="search"
              >查询</el-button
            >
            <el-button size="small" @click="restBtn">重置</el-button>
            <el-button
              type="primary"
              size="small"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1454') : false
              "
              @click="outData"
              >导出</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :align="item.align"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'money'">
                  {{ scope.row[item.prop] }}
                  <div v-if="scope.row.gift_money != 0">
                    (礼品卡抵扣{{ scope.row.gift_money }}元)
                  </div>
                  <div v-if="scope.row.coupon_money != 0">
                    (优惠券抵扣{{ scope.row.coupon_money }}元)
                  </div>
                </div>
                <div
                  v-else-if="item.prop == 'doctor_name'"
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor: pointer"
                >
                  {{ scope.row.doctor_name }}
                </div>
                <div v-else-if="item.prop == 'buy_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else-if="item.prop == 'channel_type'">
                  {{ scope.row[item.prop] | channelTypeText }}
                </div>
                <div v-else-if="item.prop == 'expire_time'">
                  <div style="display: flex">
                    <span style="margin-right: 10px">{{
                      scope.row[item.prop] | dateFormat
                    }}</span>
                    <el-tag
                      v-if="scope.row['cancel_welfare'] == 1"
                      type="danger"
                      size="small"
                      >已到期</el-tag
                    >
                  </div>
                </div>
                <div v-else-if="item.prop == 'goods_name'">
                  {{ scope.row[item.prop] }}
                  <el-tag v-if="scope.row.exchange_order_id > 0" type="danger"
                    >已领取</el-tag
                  >
                </div>
                <div v-else-if="item.prop == 'is_refund'">
                  {{
                    refundText(
                      scope.row.gift_money,
                      scope.row.money,
                      scope.row.sy_refund_money
                    )
                  }}
                </div>
                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1455')
                      : false
                  "
                  @click="toDetail(scope.row.log_id)"
                  >查看</el-button
                >

                <el-button
                  v-if="
                    scope.row['is_refund'] != 1 &&
                    (module_id_array[0]
                      ? module_id_array.includes('1664')
                      : true)
                  "
                  type="text"
                  size="medium"
                  @click="refundCardBtn(scope.row)"
                  >退款</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 退款弹窗 -->
    <el-dialog
      title="退款"
      :visible.sync="dialogRefund"
      width="500px"
      :before-close="handleClose"
    >
      <div style="padding: 20px">
        <el-form
          label-width="80px"
          :model="refundForm"
          ref="refundFormRef"
          :rules="rules"
        >
          <el-form-item label="退款金额" prop="refund_money">
            <el-input-number
              v-model="refundForm.refund_money"
              size="medium"
              :min="0"
              :max="refundForm.sy_refund_money"
              :precision="2"
              :controls="false"
              style="width: 355px"
            ></el-input-number>

            &nbsp;元
            <div style="text-align: left; color: #f56c6c; margin-top: 16px">
              最大可退金额&nbsp;{{ refundForm.sy_refund_money }}&nbsp;元
            </div>
          </el-form-item>

          <el-form-item
            label=""
            style="padding-top: 20px"
            prop="cancel_welfare"
          >
            <div style="text-align: left">
              <el-checkbox
                v-model="refundForm.cancel_welfare"
                :true-label="1"
                :false-label="0"
                :disabled="is_cancel_welfare"
                >同时取消用户养生福利</el-checkbox
              >
            </div>
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="refundForm.remark"
              size="medium"
              maxlength="100"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="验证码" prop="code" v-if="refundForm.is_show">
            <div style="display: flex">
              <el-input
                v-model="refundForm.code"
                size="medium"
                clearable
              ></el-input>
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 20px"
                @click="getCode"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1842') : false
                "
                >{{ codeText }}</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelRefund">取 消</el-button>
        <el-button type="primary" @click="comfirmRefund('refundFormRef')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
import common from "../../../api/common";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tableLoading: false,
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      healthCareCardInfo: {
        people_num: "",
        buy_num: "",
        drug_reduce_price: "",
        goods_reduce_price: "",
        give_integral: "",
      },
      healthCareCardForm: {
        nick_name: "",
        phone: "",
        buy_time: "",
        buy_num_start: undefined,
        buy_num_end: undefined,
        is_expire: -1,
        channel_type: "",
      },
      tableHeader: [
        {
          label: "用户昵称",
          prop: "nick_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "用户手机号",
          prop: "phone",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "购买时间",
          prop: "buy_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "购买实付金额",
          prop: "money",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "到期时间",
          prop: "expire_time",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "当前购买次数",
          prop: "buy_times",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "药品优惠金额",
          prop: "drug_discount_price",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "商城优惠金额",
          prop: "goods_discount_price",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "积分福利",
          prop: "integral",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "养生卡权益商品",
          prop: "goods_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "退款状态",
          prop: "is_refund",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "购买渠道",
          prop: "channel_type",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      tableData: [],
      dialogRefund: false,
      refundForm: {
        log_id: "",
        refund_money: undefined,
        cancel_welfare: 1,
        sy_refund_money: 0,
        is_show: 0,
        remark: "",
        code: "",
      },
      is_cancel_welfare: false,
      rules: {
        refund_money: [{ required: true, message: "请输入", trigger: "blur" }],
        code: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      codeText: "获取验证码",
      timer: null,
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    settlementText(val) {
      switch (val) {
        case 0:
          return "未结算";
        case 1:
          return "已结算";
      }
    },
    channelTypeText(val) {
      switch (val) {
        case 1:
          return "个人中心";
        case 2:
          return "购买处方";
        case 3:
          return "购买商品";
        case 4:
          return "VIP陪诊购买";
        default:
          return "-";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getInfo();
    this.getList();
  },
  methods: {
    // 退款状态
    refundText(gift_money, money, sy_refund_money) {
      let m1 = Number(gift_money) * 100;
      let m2 = Number(money) * 100;
      let m3 = Number(sy_refund_money) * 100;
      if (!m3) {
        return "退全额";
      }
      if (m1 + m2 == m3) {
      } else {
        return "部分退款";
      }
    },
    getInfo() {
      marketing.getStatData({ id: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.healthCareCardInfo = res.data;
        }
      });
    },
    getList() {
      this.tableLoading = true;
      let params = Object.assign({}, this.healthCareCardForm, this.pagination);
      params = _.omit(params, ["buy_time"]);
      if (
        this.healthCareCardForm.buy_time &&
        this.healthCareCardForm.buy_time.length
      ) {
        params.buy_time_start = this.healthCareCardForm.buy_time[0];
        params.buy_time_end = this.healthCareCardForm.buy_time[1];
      }
      params.id = this.$route.query.id;
      marketing
        .getUserLogListPaging(params)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.is_expire = dayjs(new Date()).unix() > item.expire_time;
              return item;
            });
            this.totalNum = res.data.total;
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    search() {
      this.pagination.page = 1;
      this.getList();
    },
    restBtn() {
      this.healthCareCardForm = {
        nick_name: "",
        phone: "",
        buy_time: "",
        buy_num_start: undefined,
        buy_num_end: undefined,
        is_expire: -1,
        channel_type: "",
      };
      this.pagination.page = 1;
      this.pagination.pageNumber = 10;
      this.getList();
    },
    // 导出
    outData() {
      let params = Object.assign({}, this.healthCareCardForm, this.pagination);
      params = _.omit(params, ["buy_time"]);
      if (
        this.healthCareCardForm.buy_time &&
        this.healthCareCardForm.buy_time.length
      ) {
        params.buy_time_start = this.healthCareCardForm.buy_time[0];
        params.buy_time_end = this.healthCareCardForm.buy_time[1];
      }
      params.id = this.$route.query.id;
      marketing.exportUserLogListExcel(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          window.open(data.url);
        }
      });
    },
    toDetail(log_id) {
      this.$router.push({
        path: "/home/marketing/healthCareCardDetails",
        query: {
          log_id,
        },
      });
    },
    // 养生卡退款
    refundCardBtn(row) {
      let { log_id, cancel_welfare, sy_refund_money, is_show } = row;
      this.refundForm.log_id = log_id;
      this.refundForm.is_show = is_show;
      this.refundForm.refund_money = undefined;
      this.refundForm.cancel_welfare = cancel_welfare;
      this.refundForm.sy_refund_money = Number(sy_refund_money);
      this.is_cancel_welfare = cancel_welfare == 1;
      this.refundForm.remark = "";
      this.dialogRefund = true;
    },
    comfirmRefund(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = _.omit(this.refundForm, "sy_refund_money", "is_show");
          params.cancel_welfare = this.is_cancel_welfare
            ? 0
            : this.refundForm.cancel_welfare;

          const loading = this.$loading();
          marketing
            .refundCard(params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("退款成功");
                this.getList();
                this.dialogRefund = false;
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取验证码
    getCode: _.throttle(
      function () {
        if (!this.codeText.includes("获")) {
          this.$message.warning("验证码已发送");
          return;
        }
        if (typeof this.refundForm.refund_money === "undefined") {
          this.$message.warning("请填写完内容");
          return;
        }
        let params = {
          log_id: this.refundForm.log_id,
          price: this.refundForm.refund_money,
          remark: this.refundForm.remark,
          cancel_welfare: this.refundForm.cancel_welfare,
        };
        const loading = this.$loading();
        common
          .healthcardRefundVerifiCode(params)
          .then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success("发送成功");
              let time = 60;
              this.timer = window.setInterval(() => {
                if (!time) {
                  this.restCode();
                  return;
                }
                time -= 1;
                this.codeText = `${time}S`;
              }, 1000);
              this.$once("hook:beforeDestroy", function () {
                this.restCode();
              });
            }
            loading.close();
          })
          .catch(() => {
            loading.close();
          });
      },
      5000,
      { trailing: false }
    ),
    // 重置验证码
    restCode() {
      window.clearInterval(this.timer);
      this.codeText = "获取验证码";
    },
    cancelRefund() {
      this.restCode();
      this.dialogRefund = false;
    },
    handleClose(done) {
      this.restCode();
      done();
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}
.overview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  .box-card {
    width: 24%;
    .value {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}
.search_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
  .item {
    height: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .itemtitle {
      display: inline-block;
      width: 80px;
      margin-right: 8px;
      text-align: right;
    }
  }
}
</style>
